// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* base styles */
* {
  margin: 0;
  /* font-family: "Quicksand"; */
  font-family: "Arial";
  font-size: 14px;
}

.heading {
  font-size: 28px;
}

.subHeading {
  font-size: 18px;
}

.navbar {
  padding: 30px;
  display: flex;
  align-items: center;
  margin: 0 auto;
  background-color: #f8f9fa;
  /* border-bottom: 1px solid #F8F9FA; */
}

.navbar .atlasButton {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  gap: 30px;
}

.home .welcome {
  padding: 30px;
  padding-left: 10%;
  background-color: #f8f9fa;
}

.home .content {
  padding: 50px;
  padding-left: 10%;
  margin: 0 auto;
}

.wrapper {
  display: grid;
  grid-template: auto;
  grid-template-columns: 20rem 20rem;
  grid-gap: 10rem;
  justify-content: center;
}

.card {
  overflow: hidden;
  background-color: #e8effd;
  box-shadow: 0 2px 2px #e8effd;
  border-radius: 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.login-card {
  overflow: hidden;
  background-color: #e8effd;
  box-shadow: 0 2px 2px #e8effd;
  border-radius: 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cardImage {
  height: 10rem;
  width: 100%;
  object-fit: cover;
}

.cardBody {
  margin: 1rem;
  text-align: center;
  /* flex-grow: 1; */
}

.cardTitle {
  padding: 1rem;
  font-size: 24;
  font-weight: bold;
}

.cardDescription {
  font-size: 18;
  display: flex;
  flex-direction: column;
}

.cardButton {
  padding: 1rem 2rem;
  margin: 1rem;
  border: 2px solid #3579f6;
  width: 75%;
  font-weight: bold;
  font-size: 18;
  color: white;
  background: #3579f6;
  border-radius: 25px;
  cursor: pointer;
  transition: transform 200ms ease-in;
  display: inline-block;
}

.cardButtonSmall {
  padding: 1rem 2rem;
  margin: 1rem;
  border: 2px solid #3579f6;
  font-weight: bold;
  font-size: 10;
  color: white;
  background: #3579f6;
  border-radius: 25px;
  cursor: pointer;
  transition: transform 200ms ease-in;
  display: inline-block;
}

.profile {
  padding: 5rem;
  padding-left: 10rem;
  margin: 0 auto;
}

.profile-home {
  padding-top: 5rem;
}

.progressbar {
  width: 50%;
  height: 10px;
  background-color: #e8effd;
  margin-bottom: 10px;
  border-radius: 0.3rem;
}

.progressbar div {
  width: 33.3%;
  height: 100%;
  border-radius: 0.3rem;
  background-color: #3579f6;
}

.form-container {
  padding-top: 4rem;
}

.form-footer {
  padding-top: 3rem;
  display: flex;
  flex-direction: row;
  gap: 40%;
}

.rider-profile-body {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.form-row {
  display: flex;
  flex-direction: row;
  gap: 10%;
}

.form-row-1 {
  display: flex;
  flex-direction: row;
  gap: 20%;
}

/* Mobile view: stack labels and inputs vertically with spacing */
.form-row-mobile {
  display: flex;
  flex-direction: column;
  gap: 1.5rem; /* vertical gap between each row */
}

.form-column-mobile {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; /* vertical gap between label and input */
}


.form-column {
  display: grid;
  grid-template-columns: repeat(n, 1fr);
  grid-gap: 2rem;
}

.form-column-1 {
  display: grid;
  grid-template-columns: repeat(n, 1fr);
}

/* .text-input{
  width: 20rem;
  padding: 7px;
  border: 1px solid #626F86;
} */

.inline-text {
  font-weight: bold;
  display: flex;
  flex-direction: row;
}

.text-component {
  background-color: #f8f9fa;
  height: 40px;
}

.driver-progressbar {
  width: 70%;
  height: 10px;
  background-color: #e8effd;
  margin-bottom: 10px;
  border-radius: 0.3rem;
}

.driver-progressbar div {
  width: 25%;
  height: 100%;
  border-radius: 0.3rem;
  background-color: #3579f6;
}

.driver-info-box-1 {
  width: 70%;
  padding: 20px;
}

.driver-info-box {
  width: 100%;
  padding: 20px;
  margin: 1px solid #f8f9fa;
  background-color: #f8f9fa;
}

.trip-elements-box {
  width: 100%;
  /* padding: 20px;
  margin: 1px solid #f8f9fa;
  background-color: #f8f9fa; */
}


.driver-box {
  padding: 20px;
  margin: 1px solid #f8f9fa;
  background-color: #f8f9fa;
}

.split-body {
  padding-top: 2rem;
  display: grid;
  grid-template: auto;
  grid-template-columns: 3fr 2fr;
  grid-gap: 10rem;
}
.split-column {
  padding-top: 3rem;
  display: flex;
  flex-direction: row;
  gap: 30%;
  padding-bottom: 2rem;
}

.split-body-equal {
  padding-top: 5rem;
  padding-left: 5rem;
  display: grid;
  grid-template: auto;
  grid-template-columns: 2fr 2fr;
  grid-gap: 10rem;
}

.split-body-equal-left-unpadded {
  padding-top: 2rem;
  display: grid;
  grid-template: auto;
  grid-template-columns: 2fr 2fr;
  grid-gap: 10rem;
}

.ride-request-box {
  width: 50%;
  padding: 20px;
  margin: 1px solid #f8f9fa;
  background-color: #f8f9fa;
}

.driver-split {
  padding-top: 1rem;
  /* padding-left: 5rem; */
  display: grid;
  grid-template: auto;
  grid-template-columns: 2fr 2fr;
  /* grid-gap: 1rem; */
}

.map-container {
  height: 80%;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA,gBAAgB;AAChB;EACE,SAAS;EACT,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAE,kCAAkC;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAE,yCAAyC;AACxD;;;AAGA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;;;;GAIG;;AAEH;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX;;8BAE4B;AAC9B;;;AAGA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;AACb","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap\");\n\n/* base styles */\n* {\n  margin: 0;\n  /* font-family: \"Quicksand\"; */\n  font-family: \"Arial\";\n  font-size: 14px;\n}\n\n.heading {\n  font-size: 28px;\n}\n\n.subHeading {\n  font-size: 18px;\n}\n\n.navbar {\n  padding: 30px;\n  display: flex;\n  align-items: center;\n  margin: 0 auto;\n  background-color: #f8f9fa;\n  /* border-bottom: 1px solid #F8F9FA; */\n}\n\n.navbar .atlasButton {\n  margin-left: auto;\n  display: flex;\n  flex-direction: row;\n  gap: 30px;\n}\n\n.home .welcome {\n  padding: 30px;\n  padding-left: 10%;\n  background-color: #f8f9fa;\n}\n\n.home .content {\n  padding: 50px;\n  padding-left: 10%;\n  margin: 0 auto;\n}\n\n.wrapper {\n  display: grid;\n  grid-template: auto;\n  grid-template-columns: 20rem 20rem;\n  grid-gap: 10rem;\n  justify-content: center;\n}\n\n.card {\n  overflow: hidden;\n  background-color: #e8effd;\n  box-shadow: 0 2px 2px #e8effd;\n  border-radius: 0.4rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.login-card {\n  overflow: hidden;\n  background-color: #e8effd;\n  box-shadow: 0 2px 2px #e8effd;\n  border-radius: 0.4rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.cardImage {\n  height: 10rem;\n  width: 100%;\n  object-fit: cover;\n}\n\n.cardBody {\n  margin: 1rem;\n  text-align: center;\n  /* flex-grow: 1; */\n}\n\n.cardTitle {\n  padding: 1rem;\n  font-size: 24;\n  font-weight: bold;\n}\n\n.cardDescription {\n  font-size: 18;\n  display: flex;\n  flex-direction: column;\n}\n\n.cardButton {\n  padding: 1rem 2rem;\n  margin: 1rem;\n  border: 2px solid #3579f6;\n  width: 75%;\n  font-weight: bold;\n  font-size: 18;\n  color: white;\n  background: #3579f6;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: transform 200ms ease-in;\n  display: inline-block;\n}\n\n.cardButtonSmall {\n  padding: 1rem 2rem;\n  margin: 1rem;\n  border: 2px solid #3579f6;\n  font-weight: bold;\n  font-size: 10;\n  color: white;\n  background: #3579f6;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: transform 200ms ease-in;\n  display: inline-block;\n}\n\n.profile {\n  padding: 5rem;\n  padding-left: 10rem;\n  margin: 0 auto;\n}\n\n.profile-home {\n  padding-top: 5rem;\n}\n\n.progressbar {\n  width: 50%;\n  height: 10px;\n  background-color: #e8effd;\n  margin-bottom: 10px;\n  border-radius: 0.3rem;\n}\n\n.progressbar div {\n  width: 33.3%;\n  height: 100%;\n  border-radius: 0.3rem;\n  background-color: #3579f6;\n}\n\n.form-container {\n  padding-top: 4rem;\n}\n\n.form-footer {\n  padding-top: 3rem;\n  display: flex;\n  flex-direction: row;\n  gap: 40%;\n}\n\n.rider-profile-body {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.form-row {\n  display: flex;\n  flex-direction: row;\n  gap: 10%;\n}\n\n.form-row-1 {\n  display: flex;\n  flex-direction: row;\n  gap: 20%;\n}\n\n/* Mobile view: stack labels and inputs vertically with spacing */\n.form-row-mobile {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem; /* vertical gap between each row */\n}\n\n.form-column-mobile {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem; /* vertical gap between label and input */\n}\n\n\n.form-column {\n  display: grid;\n  grid-template-columns: repeat(n, 1fr);\n  grid-gap: 2rem;\n}\n\n.form-column-1 {\n  display: grid;\n  grid-template-columns: repeat(n, 1fr);\n}\n\n/* .text-input{\n  width: 20rem;\n  padding: 7px;\n  border: 1px solid #626F86;\n} */\n\n.inline-text {\n  font-weight: bold;\n  display: flex;\n  flex-direction: row;\n}\n\n.text-component {\n  background-color: #f8f9fa;\n  height: 40px;\n}\n\n.driver-progressbar {\n  width: 70%;\n  height: 10px;\n  background-color: #e8effd;\n  margin-bottom: 10px;\n  border-radius: 0.3rem;\n}\n\n.driver-progressbar div {\n  width: 25%;\n  height: 100%;\n  border-radius: 0.3rem;\n  background-color: #3579f6;\n}\n\n.driver-info-box-1 {\n  width: 70%;\n  padding: 20px;\n}\n\n.driver-info-box {\n  width: 100%;\n  padding: 20px;\n  margin: 1px solid #f8f9fa;\n  background-color: #f8f9fa;\n}\n\n.trip-elements-box {\n  width: 100%;\n  /* padding: 20px;\n  margin: 1px solid #f8f9fa;\n  background-color: #f8f9fa; */\n}\n\n\n.driver-box {\n  padding: 20px;\n  margin: 1px solid #f8f9fa;\n  background-color: #f8f9fa;\n}\n\n.split-body {\n  padding-top: 2rem;\n  display: grid;\n  grid-template: auto;\n  grid-template-columns: 3fr 2fr;\n  grid-gap: 10rem;\n}\n.split-column {\n  padding-top: 3rem;\n  display: flex;\n  flex-direction: row;\n  gap: 30%;\n  padding-bottom: 2rem;\n}\n\n.split-body-equal {\n  padding-top: 5rem;\n  padding-left: 5rem;\n  display: grid;\n  grid-template: auto;\n  grid-template-columns: 2fr 2fr;\n  grid-gap: 10rem;\n}\n\n.split-body-equal-left-unpadded {\n  padding-top: 2rem;\n  display: grid;\n  grid-template: auto;\n  grid-template-columns: 2fr 2fr;\n  grid-gap: 10rem;\n}\n\n.ride-request-box {\n  width: 50%;\n  padding: 20px;\n  margin: 1px solid #f8f9fa;\n  background-color: #f8f9fa;\n}\n\n.driver-split {\n  padding-top: 1rem;\n  /* padding-left: 5rem; */\n  display: grid;\n  grid-template: auto;\n  grid-template-columns: 2fr 2fr;\n  /* grid-gap: 1rem; */\n}\n\n.map-container {\n  height: 80%;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
